import { SEVERITIES } from '@totem/components/services/threats/eventsDashboard/report/severity';
import { FindingGroup } from '@totem/components/services/threats/eventsDashboard/report/types';
import { FilterField } from '@totem/components/ui_components/reportSettings/types';

export const eventsReportConfiguration: FilterField[] = [
  {
    key: 'mode',
    label: 'View',
    sortField: '',
    filterField: 'mode',
    multiple: false,
    value: 'open',
    allowPersistence: false,
  },
  {
    key: 'dateRange',
    label: 'Date range',
    sortField: '',
    filterField: 'dateRange',
    multiple: true,
    values: [],
    allowPersistence: false,
    hideFilterChips: true,
  },
  {
    key: 'sourceType',
    label: 'Source',
    sortField: '',
    filterField: 'sourceType',
    multiple: true,
    values: [],
  },
  {
    key: 'eventType',
    label: 'Type',
    sortField: '',
    filterField: 'eventType',
    multiple: true,
    values: [],
  },
  {
    key: 'severity',
    label: 'Severity',
    sortField: '',
    filterField: 'severity',
    multiple: true,
    values: [],
    options: SEVERITIES.map((severity) => ({
      text: severity.label,
      value: String(severity.value),
    })),
  },
  {
    key: 'region',
    label: 'Region',
    sortField: '',
    filterField: 'regionId',
    multiple: true,
    values: [],
  },
  {
    key: 'building',
    label: 'Building',
    sortField: '',
    filterField: 'buildingId',
    multiple: true,
    values: [],
  },
];

// Service areas (event_categories) listed on the Security tab; every other area is on the Operations tab.
export const SECURITY_CATEGORIES = ['epsec', 'netsec'];

export const groupForCategory = (category: string): FindingGroup =>
  SECURITY_CATEGORIES.includes(category) ? 'security' : 'operations';

export const FILTER_KEYS = [
  'sourceType',
  'eventType',
  'severity',
  'region',
  'building',
];

// Filter options come from the active events, as on the v1 Events report.
export const FILTER_OPTION_KEYS = [
  'sourceType',
  'eventType',
  'region',
  'building',
];
